<template>
  <transition appear name="fade">
    <div
      v-if="value"
      class="modal"
      :class="{ 'is-active': value }"
      @keyup.esc="Hide()"
      v-on="$listeners"
    >
      <div
        class="modal-background"
        @click="closeOnBgClick ? Hide() : false"
      ></div>
      <div class="modal-content">
        <slot></slot>
      </div>
      <button
        @click="Hide()"
        class="modal-close is-large"
        aria-label="close"
      ></button>
    </div>
  </transition>
</template>

<script>
export default {
  name: "bmodal",
  components: {},
  props: ["value", "closeOnBgClick"],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  async mounted() {},
  beforeDestroy() {},
  methods: {
    Hide() {
      this.$emit("input", false);
      this.$emit("hide");
    }
  }
};
</script>

<style lang="css" scoped>
.slide-fade-modal-enter-active {
  transition: all 0.1s ease;
}

.slide-fade-modal-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-modal-enter,
.slide-fade-modal-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
